import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { Checkbox, Form, Button, Input, message, Card } from 'antd'
import { UserOutlined, LockOutlined, InsuranceOutlined } from '@ant-design/icons';
import { GetSignIn, GetUserInfo, getLoginVerifyApi } from "@/services/home"; // 引入Ajax
import local from '@/utils/local'
import './index.less'
import { getAllPermissions } from '@/services/home.js'

export default function Login (props) {
  const navigate = useNavigate()
  const [form] = Form.useForm();
  const [SigninLoading, _SigninLoading] = useState(false);
  const [isNeedCode, setIsNeedCode] = useState(false)//是否需要验证码
  const codeUrl = '/api/admin.php?service=Admin.Common.CreateCaptcha'
  // 登录
  const onFinish = async (values) => {
    _SigninLoading(true)
    const res = await GetSignIn({
      username: values.username,
      password: values.password,
      captcha: values.code,
    });
    _SigninLoading(false)
    if (res.ret !== 200) {
      _SigninLoading(false);
      message.warning(res.msg || '登录失败');
      setIsNeedCode(true)
      setTimeout(() => {
        let imgDom = document.getElementById('ChangeCode')
        imgDom.src = codeUrl
      }, 500);
      return;
    } else {
      setIsNeedCode(false)
      local.set('cruise_m350_token', res.data.access_token)
      local.set('cruise_m350_isLogin', true)
      if (values.remember) {
        local.set('cruise_m350_username', values.username);
        local.set('cruise_m350_password', values.password);
      }

      // 获取当前账号角色，并展示不同的菜单
      const res1 = await GetUserInfo({
        access_token: res.data.access_token,
      });
      if (res1.ret === 200 && await getMenuPermissions(res1)) { // eslint-disable-line
        console.log(res1);
        local.set('cruise_m350_memberLevel', res1.data.profile.member_level)
        // || ['/data_monitor', '/abnormal_troubleshooting', '/inspection_live_broadcast'].indexOf(local.get('cruise_m350_cruiseMenuKeys')) >= 0
        if (Number(local.get('cruise_m350_memberLevel')) !== 255 && (!local.get('cruise_m350_cruiseMenuKeys'))) {
          local.set('cruise_m350_cruiseMenuKeys', '/inspection_live_broadcast');
          local.set('cruise_m350_defaultOpenKeys', 'shipping_line');
          navigate('/user_manual');
        } else {
          local.set('cruise_m350_defaultOpenKeys', 'shipping_line');
          local.set('cruise_m350_cruiseMenuKeys', `/shipping_line/routine`);
          navigate('/shipping_line/routine');
        }
      } else {
        //console.log(res1.msg);
        message.warning(res1.ret !== 200 ? res1.msg : '登录失败，请稍后重试~')
      }
    };
  };


  const loginVerify = async (values) => { //登陆前的验证
    let res = await getLoginVerifyApi({ username: values.username })
    if (res.data.verify) {
      setIsNeedCode(true)
    } else {
      onFinish(values)
    }
  }

  // 获取menu权限
  const getMenuPermissions = async (arr) => {
    let res2 = await getAllPermissions({ access_token: local.get('cruise_m350_token'), member_level: arr.data.profile.member_level })
    if (res2.ret !== 200) { message.warning(res2.msg); return false }
    if (res2.data.menu && res2.data.menu.length) {
      window.localStorage.setItem('cruise_m350_permissionsArr', JSON.stringify(res2.data.menuids || []));
      return true
    }
  }


  useEffect(() => {
    let username = local.get('cruise_m350_username') || '';
    let password = local.get('cruise_m350_password') || '';
    local.clear();
    form.setFieldsValue({
      username: username,
      password: password,
      remember: true,
    });
    local.set('cruise_m350_username', username);
    local.set('cruise_m350_password', password);
    // eslint-disable-next-line
  }, [])
  return (
    <div className='home'>
      <Card>
        <div className="login jb">
          <div className="P_login">
            <div></div>
            <div
              style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', alignItems: 'center' }}>
              {/* img */}
              <div className="ipt_title" >
                <div style={{ fontSize: '31px' }}>管理系统</div>
              </div>
              {/* 表单 */}
              <div className='ipt_con'>
                <Form
                  form={form}
                  className=""
                  name="normal_login"
                  onFinish={isNeedCode ? onFinish : loginVerify}//验证码存在则直接调用登录，验证码不存在则调用验证
                >
                  <Form.Item
                    name="username"
                    rules={[
                      {
                        required: true,
                        message: '请输入账号!',
                      },
                    ]}
                  >
                    <Input size="large" prefix={<UserOutlined className="site-form-item-icon" style={{ color: '#007be4' }} />} placeholder="账号" />
                  </Form.Item>
                  <Form.Item
                    name="password"
                    rules={[
                      {
                        required: true,
                        message: '请输入密码!',
                      },
                    ]}
                  >
                    <Input.Password
                      size="large"
                      prefix={<LockOutlined className="site-form-item-icon" style={{ color: '#007be4' }} />}
                      type="password"
                      placeholder="密码"
                      style={{ marginTop: '6px' }}
                    />
                  </Form.Item>

                  {
                    isNeedCode && codeUrl &&
                    <Form.Item
                      className='h40'
                      name="code"
                      rules={[
                        {
                          required: true,
                          message: '请输入验证码',
                        },
                      ]}
                    >
                      <div className='h40 flex jcsb align_center'>
                        <Input
                          className='h40 marR8'
                          size="large"
                          prefix={<InsuranceOutlined className="site-form-item-icon" style={{ color: '#007be4' }} />}
                          // type="password"
                          placeholder="验证码"
                          style={{ width: 'calc(100% - 168px)' }}
                        />
                        <img
                          // className='w160 h40'
                          id='ChangeCode'
                          src={codeUrl}
                          alt='验证码'
                          onClick={() => {
                            let imgDom = document.getElementById('ChangeCode')
                            imgDom.src = codeUrl
                          }}
                        />
                      </div>
                    </Form.Item>
                  }




                  <Form.Item style={{ minHeight: '22px' }}>
                    <Form.Item name="remember" valuePropName="checked" noStyle className='checkbox'>
                      <Checkbox style={{ marginTop: '1px' }}>记住此账号</Checkbox>
                    </Form.Item>
                  </Form.Item>
                  <Button loading={SigninLoading} type="primary" htmlType="submit" className="wid100" size="large">
                    登录
                  </Button>
                </Form>
              </div>

            </div>

            <div className='zhanwei'></div>
            <div></div>
            {/* 底部文本框 */}
            {/* <div className='flex-col fSize14 fWei400 opacity0_45 margB27'>
              <div className='flex-row margB10 jusConCen'>
                <div className='tt_a_cen margR100'>智能科技</div>
                <div className='tt_a_cen'>Ant Design</div>
              </div>
              <div className='disFlex jusConCen'  >
                Copyright ©2022 Produced by You Shu Group Technology Department
              </div>
            </div> */}
          </div>
        </div>
      </Card>
    </div>

  )

}
